export default __webpack_public_path__ + "images/lenda_04e7b1.png";